import request from 'config/apiConfig';

export const fetchToken = (payload: { dashboardId: string }) => {
  return request.get(`analytics/dashboard/${payload.dashboardId}`, {});
};
